import React, { Component } from "react";
import axios from "axios";
//import moment from "moment";
import "./Userpaypanel.css";
import Util from "../../util/util";
import { Payform } from "../../components/payform/Payform";
import { Paypaypal } from "../../components/paypaypal/Paypaypal";

class UserPayPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: "",
      paymentlist: [],
      monthList: [
        "Januar",
        "Februar",
        "Mart",
        "April",
        "Maj",
        "Jun",
        "Jul",
        "Avgust",
        "Septembar",
        "Oktobar",
        "Novembar",
        "Decembar",
      ],
      openLink: "https://storage.googleapis.com/opk_media/factures/",
      usersData: localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : {},
    };
  }

  componentDidMount = () => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/getUserInvoices", {
        user_id: this.state.usersData.id,
      })
      .then((res) => {
        mainThis.setState({
          paymentlist: res["data"]["responseData"],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onButtonClick = (x) => {
    window.open(x);
  };

  getYear = (date) => {
    var year = new Date(date).getFullYear();
    return year;
  };
  
  
  doOpenPop = () => {
    Util.saveCustomEvent("open_pay_view");
    document.querySelector(".payform-info-popup-bank").classList.add("active");
  };

  doOpenPop2 = () => {
    Util.saveCustomEvent("open_pay_view_paypal");
    document.querySelector(".payform-info-popup-paypal").classList.add("active");
  };
  
  
  requestBill = () => {
    Util.saveCustomEvent("request_bill");

    axios.defaults.headers.common["Authorization"] = this.state.usersData.token;
    axios
      .post(window.ajaxLink + "user/requestbill")
      .then((res) => {
        Util.showPopupDialog(
          "Zatraži Predračun",
          "Hvala Vam na zahtjevu za predračun. U što kraćem roku dobićete predračun na adresu sa Vašeg profila",
          {
            title: "Zatvori",
            css: "middle_popup_yellow_button",
            callback: () => {},
          },
          { title: "", css: "", callback: () => {} },
          () => {},
          ""
        );
      })
      .catch((err) => {});
  };

  render() {
    return (
      <div className="pay_list_container">
        <div className="pay_items_page_title">Finansije</div>
        <div className="pay_list_item">
          <div className="item_header_title">OPK.ba je besplatan za koristenje - nije potrebno placanje!</div>
        </div>
      </div>
    );
  }
}

export default UserPayPanel;
